/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AssetAllocationCategory } from './AssetAllocationCategory';
import {
    AssetAllocationCategoryFromJSON,
    AssetAllocationCategoryFromJSONTyped,
    AssetAllocationCategoryToJSON,
} from './AssetAllocationCategory';

/**
 * 
 * @export
 * @interface SecurityAssetAllocation
 */
export interface SecurityAssetAllocation {
    /**
     * 
     * @type {AssetAllocationCategory}
     * @memberof SecurityAssetAllocation
     */
    category: AssetAllocationCategory;
    /**
     * 
     * @type {number}
     * @memberof SecurityAssetAllocation
     */
    weight: number;
}



/**
 * Check if a given object implements the SecurityAssetAllocation interface.
 */
export function instanceOfSecurityAssetAllocation(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "category" in value;
    isInstance = isInstance && "weight" in value;

    return isInstance;
}

export function SecurityAssetAllocationFromJSON(json: any): SecurityAssetAllocation {
    return SecurityAssetAllocationFromJSONTyped(json, false);
}

export function SecurityAssetAllocationFromJSONTyped(json: any, ignoreDiscriminator: boolean): SecurityAssetAllocation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'category': AssetAllocationCategoryFromJSON(json['category']),
        'weight': json['weight'],
    };
}

export function SecurityAssetAllocationToJSON(value?: SecurityAssetAllocation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'category': AssetAllocationCategoryToJSON(value.category),
        'weight': value.weight,
    };
}

